import { newSecretManagerElement } from "@p0security/integrations-vaulted-credential-shared";
import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

import { ACCOUNT_IDENTIFIER_PATTERN } from "./account-identifier.ts";

// copy of packages/integrations/datadog-ai/shared/src/components.ts (secretManager)
const allSecretManagers = newSecretManagerElement({
  owner: "Snowflake account",
  connector: "Snowflake",
});

const secretManager = Element({
  ...allSecretManagers,
  default: "gcp-sm",
});

const ACCOUNT_IDENTIFIER_MESSAGE =
  "Use the account identifier in the form ORGNAME-ACCOUNTNAME, with upper-case letters and digits. The account name may also contain underscores.";

const isAccountIdentifier = async (_id: string, field: string) =>
  ACCOUNT_IDENTIFIER_PATTERN.test(field)
    ? undefined
    : ACCOUNT_IDENTIFIER_MESSAGE;

export const SnowflakeAiComponents = InstallSpec({
  credential: ItemComponent({
    label: "Credential provisioning",
    description: "Allow P0 to grant AI agents access to a Snowflake account",
    type: "string",
    maturity: "beta",
    validator: isAccountIdentifier,
    schema: { secretManager },
  }),
});
